import React, { useContext } from 'react';
import { ProductsContext } from '../context/products.context';
import { GlobalFilter } from './GlobalFilter';
import OptionsOutsideLMI from './OptionsOutsideLMI';
import ListWorkforce from './ListWorkforce';

export default function FilterPanel({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  selectedFilterLMI,
  setSelectedFilterLMI,
}) {
  const {
    workforce,
    setWorkforce,
    selectedLaborView,
    setSelectedLaborView,
    jobs,
  } = useContext(ProductsContext);

  const changeFilter = (newFilter) => {
    setWorkforce(newFilter);
  };

  return (
    <div className="p-6 bg-white shadow-md rounded-lg flex flex-col space-y-3 mt-4">
      {/* Top Row */}
      {/* Tab Switcher for Table vs. Charts */}
      <div className="flex space-x-4 mt-4">
        <button
          onClick={() => setSelectedLaborView('table')}
          className={`
            px-4 py-2 rounded 
            ${selectedLaborView === 'table'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-800'}
          `}
        >
          Occupational Data (Table)
        </button>

        <button
          onClick={() => setSelectedLaborView('charts')}
          className={`
            px-4 py-2 rounded 
            ${selectedLaborView === 'charts'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-800'}
          `}
        >
          King County Employment Trends
        </button>
      </div> <div className="flex flex-col md:flex-row md:items-center md:justify-between">
        <div className="mb-4 md:mb-0">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900">
            Labor Market Information
          </h2>
          {workforce && workforce !== '(All)' ? (
            <p className="text-lg text-slate-600 mt-1">
              for <span className="font-medium text-slate-800">{workforce}</span>
            </p>
          ) : (
            <p className="text-sm text-slate-600 mt-1">
              Explore wages, growth, and more.
            </p>
          )}
          {jobs?.meta?.sourceNotes && (
            <p className="text-xs text-slate-400 mt-2 max-w-3xl leading-relaxed">
              {jobs.meta.sourceNotes.wages}
              {' · '}
              {jobs.meta.sourceNotes.projections}
              {' · '}
              {jobs.meta.sourceNotes.demand}
            </p>
          )}
        </div>

        {/* Workforce Dropdown */}
        <div className="flex items-center space-x-2">
          <label
            htmlFor="workforceDropdown"
            className="text-sm font-medium text-slate-700"
          >
            Workforce Region:
          </label>
          <ListWorkforce changeFilter={changeFilter} id="workforceDropdown" />
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-zinc-200 pt-4"></div>

      {/* Bottom Row: Search Box & Additional Filter */}
      <div className="flex flex-col md:flex-row md:items-end md:space-x-4 space-y-4 md:space-y-0">
        <div className="flex-1">
          <div className="p-4 bg-zinc-50 rounded-md shadow-sm flex flex-col">
            <label
              htmlFor="lmiSearch"
              className="block text-sm font-medium text-zinc-700 mb-2"
            >
              Search Occupations
            </label>
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              globalFilter={globalFilter}
              setGlobalFilter={setGlobalFilter}
            />
          </div>
        </div>

        {/* Additional Filter */}
        <div className="flex-1">
          <div className="p-4 bg-zinc-50 rounded-md shadow-sm">
            <OptionsOutsideLMI
              selectedFilterLMI={selectedFilterLMI}
              setSelectedFilterLMI={setSelectedFilterLMI}
            />
          </div>
        </div>
      </div>

     
    </div>
  );
}